import React, { RefObject } from "react"

import {
    BackofficeNavigationProps,
    BackofficeNavigationState,
} from "./models"

import {
    Box, Menu, MenuItem, Stack
} from "@mui/material"

import { Trans } from "@lingui/macro"

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp"
import { NavLink } from "react-router-dom"
import { UserRole } from "models"

export class BackofficeNavigation extends React.Component<BackofficeNavigationProps, BackofficeNavigationState> {

    private readonly selectContentRef: RefObject<HTMLInputElement> = React.createRef();
    private readonly selectContentListRef: RefObject<HTMLInputElement> = React.createRef();
    private readonly selectManageRef: RefObject<HTMLInputElement> = React.createRef();
    private readonly selectSubscriptionRef: RefObject<HTMLInputElement> = React.createRef();
    private readonly selectUserRef: RefObject<HTMLInputElement> = React.createRef();

    constructor(props: Readonly<BackofficeNavigationProps> | BackofficeNavigationProps) {

        super(props);

        this.state = {
            anchorContentEl: null,
            anchorContentListEl: null,
            anchorManageEl: null,
            anchorSubscriptionEl: null,
            anchorUserEl: null
        };
    }

    private openContentSelect = () => {
        this.setState(() => ({ anchorContentEl: this.selectContentRef.current }));
    }

    private closeContentSelect = () => {
        this.setState(() => ({ anchorContentEl: null }));
    };

    private openContentListSelect = () => {
        this.setState(() => ({ anchorContentListEl: this.selectContentListRef.current }));
    }

    private closeContentListSelect = () => {
        this.setState(() => ({ anchorContentListEl: null }));
    };

    private openManageSelect = () => {
        this.setState(() => ({ anchorManageEl: this.selectManageRef.current }));
    }

    private closeManageSelect = () => {
        this.setState(() => ({ anchorManageEl: null }));
    };

    private openSubscriptionSelect = () => {
        this.setState(() => ({ anchorSubscriptionEl: this.selectSubscriptionRef.current }));
    }

    private closeSubscriptionSelect = () => {
        this.setState(() => ({ anchorSubscriptionEl: null }));
    };

    private openUserSelect = () => {
        this.setState(() => ({ anchorUserEl: this.selectUserRef.current }));
    }

    private closeUserSelect = () => {
        this.setState(() => ({ anchorUserEl: null }));
    };

    render() {
        return (
            <Stack direction="row" spacing={4}>
                <Box ref={this.selectContentRef}>
                    <Stack sx={{ cursor: "pointer" }} direction="row" onClick={this.openContentSelect}>
                        <NavLink
                            to="/"
                            activeClassName="active-link"
                            className="nav-link hover"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            isActive={(match, location) => {
                                return (
                                    location.pathname === "/backoffice/content-upload" ||
                                    location.pathname === "/backoffice/manage-content"
                                );
                            }}
                        >
                            <Trans id="bn-content-link">Contenuti</Trans>
                        </NavLink>

                        {this.state.anchorContentEl ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                    </Stack>
                    <Menu
                        className="menu-appbar"
                        anchorEl={this.state.anchorContentEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        open={Boolean(this.state.anchorContentEl)}
                        onClose={this.closeContentSelect}
                    >

                        <MenuItem onClick={this.closeContentSelect}>
                            <NavLink
                                to="/backoffice/content-upload"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-upload-content-item">Carica contenuto</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeContentSelect}>
                            <NavLink
                                to="/backoffice/manage-content"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-content-item">Gestisci contenuti</Trans>
                            </NavLink>
                        </MenuItem>

                    </Menu>
                </Box>
                {(process.env.REACT_APP_CONTENT_LIST_ENABLED === "true") && <Box ref={this.selectContentListRef}>
                    <Stack direction="row" onClick={this.openContentListSelect} sx={{ cursor: "pointer" }}>
                        <NavLink
                            to="/"
                            activeClassName="active-link"
                            className="nav-link hover"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            isActive={(match, location) => {
                                return (
                                    location.pathname === "/backoffice/create-content-list" ||
                                    location.pathname === "/backoffice/manage-list"
                                );
                            }}
                        >
                            <Trans id="bn-content-list-link">Liste contenuti</Trans>
                        </NavLink>
                        {this.state.anchorContentListEl ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                    </Stack>
                    <Menu
                        className="menu-appbar"
                        anchorEl={this.state.anchorContentListEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        open={Boolean(this.state.anchorContentListEl)}
                        onClose={this.closeContentListSelect}
                    >

                        <MenuItem onClick={this.closeContentListSelect}>
                            <NavLink
                                to="/backoffice/create-content-list"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-create-content-list-item">Crea lista</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeContentListSelect} >
                            <NavLink
                                to="/backoffice/manage-list"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-content-list-item">Gestisci liste</Trans>
                            </NavLink>
                        </MenuItem>

                    </Menu>
                </Box>}
                <Box ref={this.selectManageRef}>
                    <Stack direction="row" onClick={this.openManageSelect} sx={{ cursor: "pointer" }}>
                        <NavLink
                            to="/"
                            activeClassName="active-link"
                            className="nav-link hover"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            isActive={(match, location) => {
                                return (
                                    location.pathname === "/backoffice/manage-actions" ||
                                    location.pathname === "/backoffice/manage-tag" ||
                                    location.pathname === "/backoffice/manage-festival" ||
                                    location.pathname === "/backoffice/manage-award" ||
                                    location.pathname === "/backoffice/manage-genre" ||
                                    location.pathname === "/backoffice/manage-language" ||
                                    location.pathname === "/backoffice/manage-country"
                                );
                            }}
                        >
                            <Trans id="bn-manage-link">Gestione</Trans>
                        </NavLink>
                        {this.state.anchorManageEl ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                    </Stack>
                    <Menu
                        className="menu-appbar"
                        anchorEl={this.state.anchorManageEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        open={Boolean(this.state.anchorManageEl)}
                        onClose={this.closeManageSelect}
                    >

                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-tag"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-tag-item">Gestisci tag</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-festival"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-festival-item">Gestisci festival</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-award"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-award-item">Gestisci premi</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-genre"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-genre-item">Gestisci generi</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-country"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-country-item">Gestisci paesi</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeManageSelect}>
                            <NavLink
                                to="/backoffice/manage-language"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-language-item">Gestisci lingue</Trans>
                            </NavLink>
                        </MenuItem>

                    </Menu>
                </Box>
                {(process.env.REACT_APP_CODES_AND_SUBS_ENABLED === "true") && <Box ref={this.selectSubscriptionRef}>
                    <Stack direction="row" onClick={this.openSubscriptionSelect} sx={{ cursor: "pointer" }}>
                        <NavLink
                            to="/"
                            activeClassName="active-link"
                            className="nav-link hover"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            isActive={(match, location) => {
                                return (
                                    location.pathname === "/backoffice/subscription-actions" ||
                                    location.pathname === "/backoffice/create-subscription" ||
                                    location.pathname === "/backoffice/manage-subscription" ||
                                    location.pathname === "/backoffice/manage-coupon"
                                );
                            }}
                        >
                            <Trans id="bn-subscription-link">Codici e abbonamenti</Trans>
                        </NavLink>
                        {this.state.anchorSubscriptionEl ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                    </Stack>
                    <Menu
                        className="menu-appbar"
                        anchorEl={this.state.anchorSubscriptionEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        open={Boolean(this.state.anchorSubscriptionEl)}
                        onClose={this.closeSubscriptionSelect}
                    >

                        <MenuItem onClick={this.closeSubscriptionSelect}>
                            <NavLink
                                to="/backoffice/create-subscription"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-create-subscription-item">Crea abbonamento</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeSubscriptionSelect}>
                            <NavLink
                                to="/backoffice/manage-subscription"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-subscription-item">Gestisci abbonamenti</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeSubscriptionSelect}>
                            <NavLink
                                to="/backoffice/manage-coupon"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-code-item">Gestisci codici sconto e regalo</Trans>
                            </NavLink>
                        </MenuItem>

                    </Menu>
                </Box>}
                {(this.props.user?.role === UserRole.ADMIN && (process.env.REACT_APP_USERS_ENABLED === "true")) && <Box ref={this.selectUserRef}>
                    <Stack direction="row" onClick={this.openUserSelect} sx={{ cursor: "pointer" }}>
                        <NavLink
                            to="/"
                            activeClassName="active-link"
                            className="nav-link hover"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            isActive={(match, location) => {
                                return (
                                    location.pathname === "/backoffice/create-user" ||
                                    location.pathname === "/backoffice/manage-user"
                                );
                            }}
                        >
                            <Trans id="bn-user-link">Utenti</Trans>
                        </NavLink>
                        {this.state.anchorUserEl ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                    </Stack>
                    <Menu
                        className="menu-appbar"
                        anchorEl={this.state.anchorUserEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        open={Boolean(this.state.anchorUserEl)}
                        onClose={this.closeUserSelect}
                    >

                        <MenuItem onClick={this.closeUserSelect}>
                            <NavLink
                                to="/backoffice/create-user"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-create-user-item">Crea utente</Trans>
                            </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.closeUserSelect}>
                            <NavLink
                                to="/backoffice/manage-user"
                                activeClassName="active-link"
                                className="nav-link">
                                <Trans id="bn-manage-user-item">Gestisci utenti</Trans>
                            </NavLink>
                        </MenuItem>
                    </Menu>
                </Box>}
            </Stack>);
    }

}
